import Nav from "./components/nav";
import Table from "./components/table";
import Details from "./components/details";
import Signature from "./components/signature";
import Restricted from "./components/restricted";
import { useSelector } from "react-redux";
import { inject } from '@vercel/analytics';
 
inject();

function App() {
  const restricted = useSelector((state) => state.restrict);

  if (!restricted) {
    return (
      <div className="mx-10">
      <Nav />
      <Table />
      <Details />
      <Signature />
    </div>
    )
  } else {
    return (
      <div className="mx-10">
        <Restricted />
      </div>
    );
  }
}

export default App;
